import { TOKEN_KEY, USER_KEY } from '../utils/util';
import UserApi from './UserApi';

export const isAuthenticated = () => {
    const result = validadeToken();
    return result;
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const validadeToken = () => {

    const token = localStorage.getItem(TOKEN_KEY);
    let result = true;
    if (token !== null && token !== undefined && token !== "undefined") {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        const expires = new window.Date((decoded.exp * 1000));
        const now = new window.Date();
        if (expires < now) {
            logout();
            result = false;
        } else {
            expires.setMinutes(expires.getMinutes() - 20);
            if (expires < now) {
                UserApi.refreshToken()
            }
        }

    } else {
        result = false;
    }
    return result;
};

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    // sessionStorage.removeItem('regulatoryRequest');
    if (window.location.pathname !== `/`) {
        window.location.pathname = '/';
    }
};
